import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

export const TruncatedText = ({ value, length = 50 }: { value: string; length?: number }) => {
  const [expanded, setExpanded] = useState(false);

  if (value.length <= length) {
    return <>{value}</>;
  }

  return (
    <div style={{ display: 'flex' }}>
      <div style={{ marginRight: 8 }}>{expanded ? value : `${value.substr(0, length)}...`}</div>
      <span style={{ marginLeft: 'auto' }}>
        {expanded ? (
          <a
            className="btn-link"
            href="#"
            onClick={(evt) => {
              evt.preventDefault();
              setExpanded(false);
            }}
          >
            <FormattedMessage id="common.truncate.hide" defaultMessage="Ocultar" />
          </a>
        ) : (
          <a
            className="btn-link "
            href="#"
            onClick={(evt) => {
              evt.preventDefault();
              setExpanded(true);
            }}
          >
            <FormattedMessage id="common.truncate.showAll" defaultMessage="Mostrar todo" />
          </a>
        )}
      </span>
    </div>
  );
};
